////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router'
import styled from 'styled-components'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import ArticleDatePicker from '../ArticleDatePicker'
import { articleLifeManagerActionCreators } from '../../../../../store/actions'

/////////STYLED/////////
const AddStartWithDepositWrapper = styled.div``
/////////STYLED/////////
// [63]_f): ADD START DEPOSIT

const AddStartWithDepositAction = (props) => {
	const match = useRouteMatch()

	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)
	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())

	const [dateLimit, setDateToModify] = useState(new Date())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleChangeDate = (date) => {
		setDateToModify(date)
	}

	const handleValidate = () => {
		actionsArticleLifeManager.postAddStartWithDeposit(match.params.id, 'AddStartWithDepositAction', dateLimit)
		handleCloseDatePicker()
	}

	const handleCloseDatePicker = () => {
		props.addStartWithDepositAction.close()
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.addStartWithDepositAction.close()
	}, [articleLifeManager?.isUpdate])

	useEffect(() => {
		if (props.addStartWithDepositAction?.item?.dateLimit)
			if (props.addStartWithDepositAction.show) handleChangeDate(new Date(props.addStartWithDepositAction.item.dateLimit))
	}, [props.addStartWithDepositAction.show])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<AddStartWithDepositWrapper>
			<ArticleDatePicker
				showModal={props.addStartWithDepositAction.show}
				date={dateLimit}
				handleValidate={handleValidate}
				handleClose={handleCloseDatePicker}
				handleChangeDate={handleChangeDate}
				title={translations['modal__itemRef__timeline_action_consignment_startDate_edit_title']}
				priorLimit={props.addStartWithDepositAction?.item?.dateLimit}
			/>
		</AddStartWithDepositWrapper>
	)
}

AddStartWithDepositAction.propTypes = {}

AddStartWithDepositAction.defaultPropTypes = {}

export default AddStartWithDepositAction
